import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPasswordVisibility } from "../redux/actions/authActions";
import {
  setAccountsData,
  setProfilePicture,
  setSelectedAccount,
} from "../redux/actions/AccountPageActions";
import * as LocalStorage from "../../utils/localStorage";
import { FaRegEye, FaRegEyeSlash, FaTrash } from "react-icons/fa";
import styles from "./accountStyling.module.css";

const AccountInfo = () => {
  const actionDispatch = useDispatch();
  const {
    data: accountsData,
    account,
    selectedAccount,
  } = useSelector((state) => state.accountsData);

  const { passwordVisible } = useSelector((state) => state.auth);

  const profilePicUpload = (event) => {
    const reader = new FileReader();
    if (event.target.files[0] && event.target.files[0].type.match("image.*")) {
      reader.readAsDataURL(event.target.files[0]);
    } else {
      console.error("Invalid file type");
    }
    reader.onload = function () {
      const imageSrc = reader.result;
      accountsData[account].profilePic = imageSrc;
      LocalStorage.setLSValue("accountsData", { ...accountsData });
      actionDispatch(
        setProfilePicture(LocalStorage.getLSValue("accountsData"))
      );
    };
    reader.onerror = function () {
      alert("Error reading file");
    };
  };

  const showPassword = () => {
    passwordVisible
      ? actionDispatch(setPasswordVisibility(false))
      : actionDispatch(setPasswordVisibility(true));
  };

  const onInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "accountName") {
      actionDispatch(setSelectedAccount({ ...selectedAccount, name: value }));
    } else if (name === "accountEmail") {
      actionDispatch(setSelectedAccount({ ...selectedAccount, email: value }));
    } else if (name === "password") {
      actionDispatch(
        setSelectedAccount({ ...selectedAccount, password: value })
      );
    } else if (name === "phone") {
      actionDispatch(setSelectedAccount({ ...selectedAccount, phone: value }));
    }
  };

  const updateAccountData = (event) => {
    event.preventDefault();
    const { accountName, accountEmail, password, confirmPassword, phone } =
      event.target;
    if (
      accountsData[account].name === accountName.value &&
      accountsData[account].email === accountEmail.value &&
      accountsData[account].password === password.value &&
      "" === confirmPassword.value &&
      accountsData[account].phone === phone.value
    ) {
      alert("No changes or updates!");
    } else {
      if (
        accountsData[account].password !== password.value &&
        password.value !== confirmPassword.value
      ) {
        alert("Password and re-enter password are not matching");
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          accountEmail.value
        )
      ) {
        alert("Please enter valid email. (example@example.com)");
      } else if (!/^[0-9]{6,10}$/.test(phone.value)) {
        alert("Please enter valid phone number.");
      } else if (
        accountsData[account].password !== password.value &&
        !/^(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,15}$/.test(password.value)
      ) {
        alert(
          "password should contain 7-15 characters,atleast one digit and one special character"
        );
      } else {
        const newData = {
          email: accountEmail.value,
          name: accountName.value,
          password: password.value,
          phone: phone.value,
          profilePic: accountsData[account].profilePic,
        };
        accountsData[account] = newData;
        LocalStorage.setLSValue("accountsData", { ...accountsData });
        actionDispatch(
          setAccountsData(LocalStorage.getLSValue("accountsData"))
        );
        alert(account + " account's Information Updated successfully");
      }
    }
  };

  const deletePicture = () => {
    accountsData[account].profilePic = "";
    LocalStorage.setLSValue("accountsData", { ...accountsData });
    actionDispatch(setAccountsData(LocalStorage.getLSValue("accountsData")));
  };

  useEffect(() => {
    account
      ? actionDispatch(setSelectedAccount(accountsData[account]))
      : actionDispatch(setSelectedAccount(null));
  }, [account, accountsData]);

  return accountsData ? (
    <section id={styles.AccountInfoSection}>
      <h1 className={styles.accountInfoSecHeading}>Account settings</h1>
      <div className={styles.accountInfoSecDiv}>
        <div
          className={
            selectedAccount
              ? styles.accountPictureDiv
              : styles.accountPictureDivBefore
          }
        >
          <div className={styles.accountPicDiv}>
            {selectedAccount ? (
              <img
                className={styles.accountUserPicture}
                src={selectedAccount.profilePic}
                alt={selectedAccount.name}
              ></img>
            ) : (
              <h1>user image</h1>
            )}
          </div>
          {selectedAccount && (
            <label
              className={styles.profileLabel}
              htmlFor={styles.profileInput}
            >
              <span className={styles.profileLabelSpan}>Upload New Photo</span>
              <input
                id={styles.profileInput}
                type="file"
                accept="image/jpeg, image/png, image/svg+xml, image/webP"
                onChange={profilePicUpload}
              ></input>
            </label>
          )}
          {selectedAccount && (
            <div className={styles.accountPictureDelDiv}>
              <FaTrash onClick={() => deletePicture()} />
            </div>
          )}
        </div>
        <div className={styles.accountInfoDiv}>
          <form onSubmit={updateAccountData} id={styles.accountInfoForm}>
            <div className={styles.accountNameDiv}>
              <label htmlFor={styles.accountName}>Account Name</label>
              <input
                key="name"
                id={styles.accountName}
                type="text"
                value={selectedAccount ? selectedAccount.name : "Account Name"}
                name="accountName"
                onChange={onInputChange}
                autoComplete="off"
              ></input>
            </div>
            <div className={styles.accountEmailDiv}>
              <label htmlFor={styles.accountEmail}>Account Email</label>
              <input
                key="email"
                id={styles.accountEmail}
                type="email"
                value={
                  selectedAccount ? selectedAccount.email : "Account Email"
                }
                name="accountEmail"
                onChange={onInputChange}
                autoComplete="off"
              ></input>
            </div>
            <div className={styles.accountPasswordDiv}>
              <label htmlFor={styles.accountPassword}>Password</label>
              <input
                key="password"
                id={styles.accountPassword}
                type={passwordVisible ? "text" : "password"}
                value={
                  selectedAccount
                    ? selectedAccount.password
                    : "Account password"
                }
                name="password"
                onChange={onInputChange}
                autoComplete="off"
              ></input>
              <span onClick={showPassword} className={styles.accountShowPassword}>
                {passwordVisible ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
            <div className={styles.ConfPasswordDiv}>
              <label htmlFor={styles.accountPassword2}>Re-enter Password</label>
              <input
                key="confirmPassword"
                id={styles.accountPassword2}
                type="password"
                name="confirmPassword"
                onChange={onInputChange}
                autoComplete="off"
              ></input>
            </div>
            <div className={styles.accountPhoneDiv}>
              <label htmlFor={styles.accountPhone}>Phone</label>
              <input
                key="phone"
                id={styles.accountPhone}
                type="text"
                value={
                  selectedAccount ? selectedAccount.phone : "Account phone"
                }
                name="phone"
                onChange={onInputChange}
                autoComplete="off"
              ></input>
            </div>

            {selectedAccount && (
              <button id={styles.accountFormSubmit} type="submit">
                Update your profile
              </button>
            )}
          </form>
          {selectedAccount && (
            <button id={styles.deleteAccountButton}>Delete your account</button>
          )}
        </div>
      </div>
    </section>
  ) : (
    ""
  );
};

export default AccountInfo;
